export default Object.freeze({
  VIDEO_TYPE: "video",
  IMAGE_TYPE: "image",
  MAX_NUMBER_IMAGES: 9,
  DEVELOPMENT_VIDEO_URL:
    "https://culturehq-direct-uploads.s3.us-west-2.amazonaws.com/b852ca03-bffa-4040-b7f3-00a39a4d195c.mp4"
});
